import { useSelector } from "react-redux";
import { REIProgressSpinner } from "../../../../components/ui";
import { IAnalysisSummaryResponse } from "../../../../interface/analysisSummary";
import { RootState } from "../../../../store";
import REIToggablePanel from "../../../../components/ui/toggablePanel";
import PreTaxVsPostTax from "./PreTaxVsPostTax";
import MarketVsLoanValue from "./MarketVsLoanValue";
import WhoPays from "./WhoPays";

const AnyalysisGraph: React.FC = () => {
  const analysisData = useSelector((state: RootState) => state.analyser.analysisSummary as IAnalysisSummaryResponse);
  const hasGraphData =
    !!analysisData?.AnalysisCashDeduction &&
    !!analysisData?.AnalysisSummary &&
    !!analysisData?.AnalysisOverview &&
    !!analysisData?.WhoPays?.UpdatedTaxman &&
    !!analysisData?.WhoPays?.Tenants &&
    !!analysisData?.WhoPays?.You;

  if (!hasGraphData) {
    return (
      <div className="w-full text-center">
        <REIProgressSpinner />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3 p-1">
      <REIToggablePanel
        customClassName="shadow-md h-full "
        header="Who Pays?"
        defaultCollapse={false}
        istoggleable={false}
        contentComponent={<WhoPays></WhoPays>}
      ></REIToggablePanel>
      <REIToggablePanel
        customClassName="shadow-md h-full "
        header="Market value vs loan"
        defaultCollapse={false}
        istoggleable={false}
        contentComponent={<MarketVsLoanValue></MarketVsLoanValue>}
      ></REIToggablePanel>
      <REIToggablePanel
        customClassName="shadow-md h-full "
        header="Cash flows: pre-tax vs after-tax"
        defaultCollapse={false}
        istoggleable={false}
        contentComponent={<PreTaxVsPostTax></PreTaxVsPostTax>}
      ></REIToggablePanel>
    </div>
  );
};
export default AnyalysisGraph;
